<h6 class="loginHeadingText text-start">PROJECT DETAILS</h6>
<div class="row mb-12px">
    <div class="col-md-3">
        <label for="projectTitle" class="required">PROJECT TITLE</label>
    </div>
    <div class="col-md-9">
        <input id="projectTitle" type="text" class="form-control" [disabled]="disableAll"
            [(ngModel)]="selectedGenInfoProject.projectTitle" (ngModelChange)="onAnyFieldValueChange($event)" maxlength="200" appUnsavedChanges>
    </div>
</div>

<div class="row mb-12px">
    <div class="col-md-3">
        <label for="pwrRequestNo">PWR REQUEST#</label>
    </div>
    <div class="col-md-9">
        <div class="row">
            <div class="col-md-5">
                <input  id="pwrRequestNo" type="text" [disabled]="!enablePWR"
                    class="form-control" [(ngModel)]="selectedGenInfoProject.pwrNumber"
                    (ngModelChange)="onAnyFieldValueChange($event)">
            </div>
            <div class="col-md-2 align-self-center px-0 text-end">
                <label for="">ISO SPOC</label>
            </div>
            <div class="col-md-5">
                <select class="form-select" aria-label="Default select example"
                    [(ngModel)]="selectedGenInfoProject.sreSpoc"
                    [disabled]="disableAll"
                    (ngModelChange)="onAnyFieldValueChange($event)"
                    (change)="onSpocChange($event)">
                    <option selected="" value="0">Select SPOC</option>
                    <option *ngFor="let item of sreUsers" [value]="item.userID">
                        {{ item.firstname + " " +  item.lastname}}
                    </option>
                </select>
            </div>
        </div>
    </div>
</div>

<!-- <div class="row mb-12px">
    <div class="col-md-3">
        <label for="summary">BRIEF SUMMARY</label>
    </div>
    <div class="col-md-9">
        <textarea id="summary" class="form-control h-115" spellcheck="false" 
            [disabled]="disableAll" (ngModelChange)="onAnyFieldValueChange($event)"
            [(ngModel)]="selectedGenInfoProject.summary" maxlength="2000">
        </textarea>
    </div>
</div> -->
